import { writable, type Writable } from 'svelte/store';

export type AuthStatus = 'checking' | 'signedOut' | 'signedIn' | 'denied' | 'error';

export interface AuthUser {
  uid: string;
  email: string;
  displayName: string | null;
}

export interface AuthState {
  status: AuthStatus;
  user: AuthUser | null;
  error: string | null;
}

const ALLOWED_DOMAIN = 'pontotel.com.br';

export interface AuthStore extends Writable<AuthState> {
  setUser(user: AuthUser | null): void;
  setError(message: string): void;
}

export function createAuthStore(): AuthStore {
  const initial: AuthState = { status: 'checking', user: null, error: null };
  const { subscribe, set, update } = writable<AuthState>({ ...initial });

  return {
    subscribe,
    set,
    update,
    setUser(user) {
      if (user === null) {
        set({ status: 'signedOut', user: null, error: null });
        return;
      }
      const okDomain = user.email.toLowerCase().endsWith(`@${ALLOWED_DOMAIN}`);
      if (!okDomain) {
        set({
          status: 'denied',
          user: null,
          error: `Domínio não permitido. Apenas contas @${ALLOWED_DOMAIN} têm acesso.`,
        });
        return;
      }
      set({ status: 'signedIn', user, error: null });
    },
    setError(message) {
      update((s) => ({ ...s, status: 'error', error: message }));
    },
  };
}

export const authStore = createAuthStore();
